<template>
  <span>
    <viewer
      v-if="validImages.length"
      :options="options"
      :images="validImages"
      @inited="init"
      class="hidden-viewer"
      ref="viewer"
    >
      <img v-for="(src, index) in validImages" :key="index" :src="src" style="display: none" />
    </viewer>

    <span @click="show">
      <slot />
    </span>
  </span>
</template>

<script>
import { component as ViewerComponent } from 'v-viewer'
import 'viewerjs/dist/viewer.css'

export default {
  components: {
    viewer: ViewerComponent
  },
  props: {
    images: {
      type: Array,
      default: () => []
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    init(viewer) {
      this.$viewer = viewer
    },
    show() {
      if (!this.validImages.length || !this.$viewer?.show) {
        return
      }

      this.$nextTick(() => {
        this.$viewer.show()
      })
    }
  },
  computed: {
    validImages() {
      return (this.images ?? []).filter(item => typeof item === 'string' && item.trim() !== '')
    }
  }
}
</script>

<style scoped>
.hidden-viewer {
  position: absolute;
  width: 0;
  height: 0;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
}
</style>
